import { api } from "@/modules/api";
import type { ApiSchema } from "@/modules/api";

export async function requestMeetingBriefing({
  spaceAccountId,
  activeNoteId,
  contextId,
  connectedCalendarEventId,
  forceGenerate = false,
  forceRegenerate = false,
}: {
  spaceAccountId: string;
  activeNoteId: string;
  contextId: string;
  connectedCalendarEventId: string;
  forceGenerate?: boolean;
  forceRegenerate?: boolean;
}): Promise<ApiSchema["SmartViewResponseSchema"]> {
  const response = await api.post(
    "/v2/smart-views/by-context/{smart_context_id}/meeting-briefing",
    {
      params: {
        path: { smart_context_id: contextId },
      },
      body: {
        context: {
          space_account_id: spaceAccountId,
          active_note_id: activeNoteId,
          smart_view_kind: "HEADS_UP",
        },
        connected_calendar_event_id: connectedCalendarEventId,
        force_generate: forceGenerate,
        force_regenerate: forceRegenerate,
      },
    }
  );

  if (!response.data) {
    throw new Error("Failed to request meeting briefing");
  }

  return response.data;
}
